import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    InviteAdminMutation,
    InviteAdminMutationVariables,
    RemoveAdminMutation,
    RemoveAdminMutationVariables
} from 'generated/graphql'

const inviteAdminMutation = gql`
    mutation inviteAdmin($data: InviteAdmin!) {
        inviteAdmin(data: $data)
    }
`
export const inviteAdmin = (eventSlug, email) => {
    const mutation = graphql.createQuery<
        InviteAdminMutation, InviteAdminMutationVariables
    >(inviteAdminMutation)
    return mutation({ data: { event: eventSlug, email } })
}

const removeAdminMutation = gql`
    mutation removeAdmin($data: RemoveAdmin!) {
        removeAdmin(data: $data)
    }
`
export const removeAdmin = (eventSlug, id) => {
    const mutation = graphql.createQuery<
        RemoveAdminMutation, RemoveAdminMutationVariables
    >(removeAdminMutation)
    return mutation({ data: { event: eventSlug, id } })
}
